import React from 'react';
import { CustomViz } from 'apps/sigma2-ui/src/components/custom-viz/CustomViz';
import { DynamicPipelineAnalysisFullInterface } from 'apps/sigma2-ui/src/components/dynamic-pipeline-analysis/DynamicPipelineAnalysisFullInterface';
import { PipelineAnalysisCustomVizDefinition } from 'libs/end-to-end/src/custom-viz/PipelineAnalysisDefinition';
import { MyObservation } from 'libs/end-to-end/src/my-observation';
import { UserAuthenticatedApiCall } from 'apps/sigma2-ui/src/state/user-types';

export const DynamicPipelineAnalysisTab = ({
  myObservation,
  organizationId,
  userAuthenticatedApiCall,
  analysisName,
}: {
  myObservation: MyObservation | null;
  organizationId: string | null;
  userAuthenticatedApiCall: UserAuthenticatedApiCall;
  analysisName: string;
}) => {
  if (!myObservation || !organizationId) {
    return <></>;
  }

  return (
    <div className="col-span-full">
      <CustomViz
        customVizDefinition={PipelineAnalysisCustomVizDefinition}
        observation={myObservation.type}
        organizationId={organizationId}
        userAuthenticatedApiCall={userAuthenticatedApiCall}
      >
        <DynamicPipelineAnalysisFullInterface
          key={analysisName}
          observation={myObservation}
          organizationId={organizationId}
          analysisName={analysisName}
        />
      </CustomViz>
    </div>
  );
};
